export var HEADER = "HEADER";
export var Scroll_Header = "Scroll_Header";
export var STREAM = "STREAM";
export var Show_Header = "Show_Header";
export var SHOW_FIXED_NAV = "SHOW_FIXED_NAV";
export var HEADER_BG_PROPERTIES = "HEADER_BG_PROPERTIES";
